import { render, staticRenderFns } from "./ClimbingSessionItem.vue?vue&type=template&id=b76f902a"
import script from "./ClimbingSessionItem.vue?vue&type=script&lang=js"
export * from "./ClimbingSessionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports